import { render, staticRenderFns } from "./priceManual.vue?vue&type=template&id=af8a80b0&scoped=true&"
import script from "./priceManual.vue?vue&type=script&lang=js&"
export * from "./priceManual.vue?vue&type=script&lang=js&"
import style0 from "./priceManual.vue?vue&type=style&index=0&id=af8a80b0&prod&lang=scss&scoped=true&"
import style1 from "./priceManual.vue?vue&type=style&index=1&id=af8a80b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af8a80b0",
  null
  
)

export default component.exports